<template>
  <a-layout class="approved-application-box">
    <a-card class="create-application" :bordered=false :loading="loading">
      <div slot="title" v-if="pageLayout.pageTitle">
        <a-icon style="cursor:pointer;" type="left-circle" @click="back" />
        <div>{{pageLayout.pageTitle}}</div>
      </div>
      <div slot="extra" style="cursor:pointer" class="extra" v-if="pageLayout.functions">
        <span v-for="(item,index) in pageLayout.functions" :key="index" style="margin-left:17px;">
          <span class="extra-trigger" @click="print" v-if="item.action==='print'">
            <a-icon style="cursor:pointer" slot="suffixIcon" :component="'SvgIcFile'" />打印
          </span>
        </span>
      </div>
      <div v-for="(layout,index) in pageLayout.contents" :key="index" v-if="loadedInfo && !loading">
        <common-form :ref="'commonForm'" :layout="layout" v-if="layout.type==='commonForm'" :params="layout.field && params[layout.field]?params[layout.field]:{}" @changed-fields="onFieldChange"></common-form>
        <multi-form :ref="'multiForm'" :layout="layout" v-if="layout.type==='multiForm'" :params="layout.field && params[layout.field]?params[layout.field]:[]" @changed-fields="onFieldChange"></multi-form>
        <summation :layout="layout" v-if="layout.type==='summation'" :params="params[layout.field]?params[layout.field]:{}" :all-params="params" @changed-fields="setSummationInfo" :from-detail="true"></summation>
        <upload v-if="layout.type==='upload'" :layout="layout" :params="params[layout.field]?params[layout.field]:[]" :can-edit="canEdit"></upload>
        <a-divider/>
      </div>
      <approval-flow :params="approvalFlowInfo" :init-text="'审批流数据加载中...'" v-if="loadedInfo && !loading"></approval-flow>
      <div style="text-align:center" v-else>
        <a-spin tip="数据加载中..."></a-spin>
      </div>
      <a-row class="footer">
        <a-col :xs="24" :sm="4"></a-col>
        <a-col :xs="24" :sm="20">
          <a-button @click="visibleComment = true" style="width:120px;" v-if="loadedInfo && !loading">评论</a-button>
        </a-col>
      </a-row>
    </a-card>
    <comment-and-copy :visible="visibleComment" @cancel="visibleComment = false" @reload="reload"></comment-and-copy>
    <form-modal :basic-modal="approvalModal" :form-layout="approvalInfolModal" @submit="approvalModalSubmit" @cancel="approvalModalCancel"></form-modal>
  </a-layout>
</template>

<script>
import UUID from "uuidjs";

import SvgIcBackbtn from "../../assets/svg/ic-left-circle-o.svg";
import SvgIcFile from "../../assets/svg/ic-file-o.svg";
import CommonForm from "../../components/CommonForm.vue";
import MultiForm from "../../components/MultiForm.vue";
import Summation from "../../components/Summation.vue";
import ApprovalFlow from "../../components/ApprovalFlow.vue";
import FormModal from "../../components/FormModal.vue";
import Upload from "../../components/Upload.vue";

import { setTimeout } from "timers";
import LayoutConfig from "../../utils/LayoutConfig.js";
import { layoutConfig } from "../../utils/mockData.js";
import {
  backInfoFormModal,
  agreeInfoFormModal
} from "../../data/formModalConfigs.js";
import {
  getLayoutDetailApi,
  getPaymentDetail,
  approvalApplication,
  getDetailApprovalFlow,
  printUrl
} from "../../services/CommonService.js";

export default {
  components: {
    SvgIcBackbtn,
    SvgIcFile,
    CommonForm,
    MultiForm,
    Summation,
    ApprovalFlow,
    FormModal,
    Upload
  },
  data() {
    return {
      canEdit: false,
      breadcrumb: [
        {
          label: "我已审批",
          path: ""
        }
      ],
      cardHeight: 0,
      params: {},
      loading: false,
      loadedInfo: false,
      pageLayout: {},
      approvalModal: {
        visible: false,
        title: "打回",
        contentTitle: "你确定拒绝付款申请吗?",
        width: 560,
        formItemLayout: {
          layout: "vertical",
          labelCol: {
            xs: { span: 24 },
            sm: { span: 24 }
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 }
          }
        }
      },
      approvalInfolModal: [],
      approvalFlowInfo: [],
      visibleComment: false
    };
  },

  created() {
    this.id = this.$route.query.id;
    this.fetchLayout();
    this.getPaymentDetail();
    this.fetchApprovalFlow();
  },
  mounted() {},

  computed: {},

  methods: {
    fetchApprovalFlow() {
      getDetailApprovalFlow({ id: this.$route.query.id }).then(res => {
        if (res.status === "success") {
          res.data.forEach((item, index) => {
            this.$set(this.approvalFlowInfo, index, item);
          });
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    onFieldChange(e) {
      this.params = Object.assign({}, this.params, e);
    },
    setSummationInfo(e) {
      this.summationInfo = e;
    },
    fetchLayout() {
      this.loading = true;
      getLayoutDetailApi({
        id: this.id,
        menu_type: 3,
        ding_msg_switch:
          window.location.href.indexOf("fromLocation=msg") !== -1 ? 1 : 0
      }).then(res => {
        if (res.status === "success") {
          this.pageLayout = res.data;
          this.loading = false;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getPaymentDetail() {
      getPaymentDetail({ type: "detail", id: this.id, menu_type: 3 }).then(
        res => {
          if (res.status === "success") {
            this.params = Object.assign({}, this.params, res.data);
            this.loadedInfo = true;
          } else {
            this.$Message.error(res.message);
          }
        }
      );
    },
    submit() {
      let validateResult = true;
      this.$refs.commonForm.forEach(item => {
        if (!item.validateFields()) {
          validateResult = false;
        }
      });
      this.$refs.multiForm.forEach(item => {
        if (!item.validateFields()) {
          validateResult = false;
        }
      });
      if (validateResult) {
        let requestParams = _.cloneDeep(this.params);
        requestParams = Object.assign({}, requestParams, this.summationInfo);
      }
    },
    back() {
      this.$router.replace({
        name: "approvedByMeList"
      });
    },
    approval(e) {
      this.approvalModal.visible = true;
      if (e) {
        this.approvalInfolModal = agreeInfoFormModal;
        this.approvalModal.title = "同意";
        this.approvalModal.contentTitle = "你确定同意此付款申请吗";
        this.approvalStatus = 2;
      } else {
        this.approvalInfolModal = backInfoFormModal;
        this.approvalModal.title = "拒绝";
        this.approvalModal.contentTitle = "你确定拒绝此付款申请吗";
        this.approvalStatus = 3;
      }
    },
    approvalModalSubmit(e) {
      let params = {
        applyId: this.$route.query.id,
        status: this.approvalStatus,
        comment: e.reason
      };
      approvalApplication(params).then(res => {
        if (res.status === "success") {
          this.approvalModal.visible = false;
          this.$Message.success("审批成功");
        } else {
          this.$Message.error(res.massage);
        }
      });
    },
    approvalModalCancel() {
      this.approvalModal.visible = false;
    },
    print() {
      const accessToken = localStorage.getItem("accessToken");
      location.href = `${window.location.origin}/api/oa/payment/pdf/${
        this.$route.query.id
      }?accessToken=${accessToken}`;
      // this.axios.get(`${printUrl}${this.$route.query.id}`).then(res => {
      //   if (res.status === 'success') {
      //     this.$Message.success(res.data);
      //   } else {
      //     this.$Message.error(res.message);
      //   }
      // });
    },

    reload() {
      this.visibleComment = false;
      this.fetchApprovalFlow();
    }
  }
};
</script>

<style lang="less">
.approved-application-box {
  padding: 16px;
}
</style>
